/**
 * Error returned when maximum precision is exceeded
 */
export default class DecimalPrecisionError extends Error {
  public ERROR_CODE = 'PRECISION_TOO_LONG';
  constructor(message : string) {
    super(message);

    Object.setPrototypeOf(this, DecimalPrecisionError.prototype);
  }
}
